import type React from 'react';

import { ChecklistFieldType } from '@cobliteam/api-lib';

import { RuleIconCb } from '@cobliteam/base-components';

import {
  CheckCircleRounded,
  NotesRounded,
  RadioButtonCheckedRounded,
} from '@material-ui/icons';

export interface ChecklistIconProps {
  checklistType: ChecklistFieldType;
  className?: string;
}

const checklistIcon = {
  [ChecklistFieldType.CHECK]: CheckCircleRounded,
  [ChecklistFieldType.TEXT]: NotesRounded,
  [ChecklistFieldType.MULTI_SELECT]: RuleIconCb,
  [ChecklistFieldType.SINGLE_SELECT]: RadioButtonCheckedRounded,
};

export const ChecklistIcon: React.FC<ChecklistIconProps> = ({
  checklistType,
  className,
}) => {
  const Icon = checklistIcon[checklistType];

  return <Icon className={className} />;
};
